import { Form, Button, Col, Row, Card } from 'react-bootstrap';
import { Chart } from "react-google-charts";

export default function Report() {
    const data = [
        [
            "Site",
            "Total Operating Costs",
            "Heating Fuel",
            "Electricity",
            "Water and Sewerage"
        ],
        ["Pennsbury", 112686.35, 17891.14, 39170.80, 0],
        ["Landis Valley", 270089.02, 55702.45, 110073.83, 9688.54],
        ["Ephrata", 94353.13, 3007.46, 31452.28, 937.37],
        ["Military", 91060.55, 3492.95, 25053.22, 2560.15],
        ["Erie", 168459.20, 0, 68893.42, 4776.03],
    ];

    const options = {
        title: "Operating Costs and Specific Costs",
        vAxis: { title: "Costs" },
        hAxis: { title: "Site" },
        seriesType: "bars",
        series: { 5: { type: "line" } },
    };

    // Facility Use Table 
    const facility_data = [
        ["Site", "Associate", "Associate %", "PHMC", "PHMC % ", "Total"],
        ["Pennsbury", { v: 1994.99, f: "$1,994.99" }, "99.75%", "$5.01", "0.25%", "$2,000"],
        ["Landis Valley", { v: 152190.44, f: "$152,190.44" }, "99.75%", "$381.431", "0.25%", "$152,572"],
        ["Epharata", { v: 1353.75, f: "$1,353.75" }, "99.75%", "$71.25", "5.00%", "$1,425"]

    ];

    const facility_options = {
        title: "Facility Use CY 2018",
        curveType: "function",
        legend: { position: "bottom" },
        pageSize: 10,
    };

    // Avg Revenue Event Table 
    const avg_revenue_event_data = [
        ["Site", "# of Events", "Facility Use Revenue", "Avg. Revenue/Event"],
        ["Pennsbury", "1", "2000", "$2000"],
        ["Landis Valley", "40", "152572", "$3814.30"],
        ["Epharata", "2", "1425", "$712.50"],
        ["Military", "35", "9800", "$280.00"],
        ["Erie", "20", "5800", "$290.00"],
        ["Anthracite", "4", "17449", "$4,362.14"],
    ];

    const avg_revenue_event_options = {
        title: "Avg. Revenue Per Event",
        curveType: "function",
        legend: { position: "bottom" },
        pageSize: 10,
    };
    return (
        <>

            <Row className="mb-0 main-content">
                <Form.Group as={Col} controlId="formGridEmail" >
                    <Form.Label>SiteName*</Form.Label>
                    <Form.Select defaultValue="Select" name="siteName" >
                        <option>All</option>
                        <option>ANTHRACITE HERITAGE</option>
                        <option>BRANDYWINE BATTLEFIELD</option>
                        <option>CORNWALL</option>
                        <option>DRAKE WELL</option>
                        <option>ECKLEY MINERS' VLGE</option>
                        <option>EPHRATA CLOISTER</option>
                        <option>ERIE MARITIME</option>
                        <option>LANDIS VALLEY</option>
                        <option>LUMBER MUSEUM</option>
                        <option>MILITARY MUSEUM</option>
                        <option>OLD ECONOMY</option>
                        <option>PENNSBURY</option>
                        <option>RAILROAD MUSEUM</option>
                    </Form.Select>

                </Form.Group>

                <Form.Group as={Col} controlId="formGridPassword">
                    <Form.Label>Year*</Form.Label>
                    <Form.Select defaultValue="Choose..." name="month"  >
                        <option>2014-15</option>
                        <option>2015-16</option>
                        <option>2016-17</option>
                        <option>2017-18</option>
                        <option>2018-19</option>
                        <option>2019-20</option>
                        <option>2020-21</option>
                        <option>2021-22</option>
                        <option>2022-23</option>
                    </Form.Select>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridPassword">
                    <Form.Label>Report</Form.Label>
                    <Form.Select defaultValue="Choose..." name="month"  >
                        <option>Facility Use Program Revenue</option>
                        <option>Facility Use Avg Revenue Per Event</option>
                        <option>Operating Expenses</option>
                        <option>Revenue and Operating Costs</option>
                        <option>General Statics</option>
                        <option>Facility Use-Administrative Work</option>
                        <option>Facility Use-Pre Monitoring</option>
                        <option>Facility Use-Post Event Setup</option>
                    </Form.Select>
                </Form.Group>
                <Col>

                    <Button>Search</Button>
                </Col>

            </Row>

            Facility Use CY 2018
            <Chart
                chartType="Table"
                width="100%"
                height="100%"
                data={facility_data}
                options={facility_options}
            />
            Avg. Revenue Per Event
            <br />
            <Chart
                chartType="Table"
                width="100%"
                height="100%"
                data={avg_revenue_event_data}
                options={avg_revenue_event_options}
            />
            <br />
            <Chart
                chartType="ComboChart"
                width="100%"
                height="400px"
                data={data}
                options={options}
            />
            <br />


        </>
    );
}